import { render } from "./index.vue?vue&type=template&id=64211e89&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=64211e89&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-64211e89"

export default script